import type { GenericLayer, LayerType } from "../../types";
import { sitesClickResolver } from "../AlwaysOnSitesLayerType/sitesClickResolver";
import { SitesSelectionSidebar } from "./SitesSelectionSidebar";
import { SiteRightClickMenu } from "./SitesRightClickMenu";
import { SitesControlPage } from "./ControlPage";
import { SitesMapLayer } from "./SitesMapLayer";

export type SitesLayer = GenericLayer<{
  captureInternalPolygonClicks?: boolean;
}>;

export const SitesLayerType: LayerType = {
  id: "SITES_LAYER_TYPE_ID",
  SelectionSidebar: SitesSelectionSidebar,
  MapLayer: SitesMapLayer,
  RightClickMenu: SiteRightClickMenu,
  clickResolver: sitesClickResolver,
  ControlPage: SitesControlPage,
};
